// extracted by mini-css-extract-plugin
module.exports = {"rowPadding":"rowcolumns_rowPadding__2cHkO","rowPaddingOne":"rowcolumns_rowPaddingOne__OdYj9"};